module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAAXNSR0IArs4c6QAAAFRQTFRFAAAAVVVVYmJiZmZmY2NjaGhoZmZmZGRkaGhoZ2dnZ2dnZ2dnaGhoZ2dnZWVlZ2dnZmZmZWVlZmZmZWVlZWVlZmZmZmZmZmZmZmZmZmZmZWVlZmZmjzECKAAAABt0Uk5TAAMNGSQ7PEJCSE9ZW1xiY4ScpbXW197r9ff5BExNRgAAAE5JREFUGNNjYCAFcItLw4GUECNEUFyAFQ44JTghgtKsSNrEeMgQZGLnAAEWFEFeSTAQJqydmY8fBNhQBLlEREFAkEwnESmINUCwBh1xAAA1IQi+XFhP8gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/open/leftbar_icon_order_n.png
// module id = bMeD
// module chunks = 1